<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle" v-if="userLogado">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons" v-if="!userLogado">
			<button class="p-link" v-tooltip.bottom="'Entrar'" @click="onLogin()">
				<span class="layout-topbar-item-text">User</span>
				<span class="layout-topbar-icon pi pi-user" ></span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: mapState(['userLogado']),
    methods: {
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
		},
		onLogin(){
			this.$router.push({path:'/portalservidor'})
		}
		
    }
}
</script>